import { render, staticRenderFns } from "./ComparisonPage.vue?vue&type=template&id=7ad637d4&"
import script from "./ComparisonPage.vue?vue&type=script&lang=js&"
export * from "./ComparisonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports